import { webMcpToolSpecs } from "./schemas";

const WRITE_TOOLS = new Set(["add_to_watchlist"]);

export function isWebMcpTestHost(): boolean {
  if (typeof window === "undefined") return false;
  return (
    window.location.hostname === "test.riskweather.io" ||
    process.env.NEXT_PUBLIC_WEBMCP === "true"
  );
}

export function getModelContext(): any | null {
  if (typeof document === "undefined") return null;
  const doc = document as any;
  const nav = typeof navigator !== "undefined" ? (navigator as any) : null;
  const ctx = doc.modelContext || nav?.modelContext;
  if (ctx && typeof ctx.registerTool === "function") return ctx;
  return null;
}

async function executeViaApi(name: string, args: Record<string, any>) {
  const res = await fetch("/api/webmcp/execute", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ name, arguments: args || {} }),
  });
  return res.text();
}

export async function registerWebMcpTools(signal?: AbortSignal): Promise<{
  api: boolean;
  registered: string[];
  errors: string[];
}> {
  const ctx = getModelContext();
  const registered: string[] = [];
  const errors: string[] = [];
  if (!ctx) {
    return { api: false, registered, errors: ["document.modelContext unavailable"] };
  }
  for (const spec of webMcpToolSpecs) {
    try {
      await ctx.registerTool(
        {
          name: spec.name,
          description: spec.description,
          inputSchema: spec.parameters,
          annotations: {
            readOnlyHint: !WRITE_TOOLS.has(spec.name),
            untrustedContentHint: spec.name === "get_asset_news",
          },
          execute: async (args: Record<string, any>) => {
            const text = await executeViaApi(spec.name, args);
            if (spec.name === "open_asset_page") {
              try {
                const parsed = JSON.parse(text);
                if (parsed?.navigated) window.location.href = parsed.navigated;
              } catch {
                // keep tool result even if navigation parsing fails
              }
            }
            return text;
          },
        },
        signal ? { signal } : undefined
      );
      registered.push(spec.name);
    } catch (err: any) {
      errors.push(`${spec.name}: ${err?.message || String(err)}`);
    }
  }
  return { api: true, registered, errors };
}
